module.exports = __webpack_public_path__ + "static/media/int_2-min.e062d43e.webp";